<template>
  <div 
    v-if="hasOmschrijving.length > 0" 
    class="pull-right"
  >
    <b-badge 
      :id="`notes-${index}`" 
      variant="warning" 
      class="mx-2"
    >
      <i class="fa fa-sticky-note-o" /> {{ hasOmschrijving.length }}
    </b-badge>
    <b-popover 
      :target="`notes-${index}`" 
      triggers="hover focus" 
      title="Opmerkingen"
    >
      <b-list-group>
        <b-list-group-item 
          v-for="(opm,index) in hasOmschrijving" 
          :key="index"
        >
          {{ opm.omschrijving }}
        </b-list-group-item>
      </b-list-group>
    </b-popover>
  </div>
</template>
<script>
export default {
    name: 'StickyNote',
    components: {},
    mixins: [],
    props: {
        notes: {
            type:Array,
            default: () => {}
        },
        index: {
            type: Number,
            default: null
        }
    },
    data() {
        return  {
        }
    },
    computed: {
        hasOmschrijving: function ()  {
            return this.notes.filter((i) => i.omschrijving )
        }
    },
    watch: {},
    mounted () {
        
    },
    methods: {},
          
}
</script>